import React, { useEffect, useRef, useState } from 'react';
import invariant from 'tiny-invariant';
import { dropTargetForElements } from '@atlaskit/pragmatic-drag-and-drop/element/adapter';

import './kanbanCard.css';

const KanbanCard = ({
    id,
    title,
    items,
    onNotFeasible,
    kanbanItemRenderer,
    totalCards,
}) => {
    const layout = totalCards <= 4 ? 4 : 5;
    const columnRef = useRef(null);
    const [isDraggedOver, setIsDraggedOver] = useState(false);

    useEffect(() => {
        const columnEl = columnRef.current;
        invariant(columnEl);
        return dropTargetForElements({
            element: columnEl,
            onDragStart: () => setIsDraggedOver(true),
            onDragEnter: () => setIsDraggedOver(true),
            onDragLeave: () => setIsDraggedOver(false),
            onDrop: () => setIsDraggedOver(false),
            getData: () => ({ columnId: id }),
            getIsSticky: () => true,
        });
    }, [id]);

    return (
        <div
            ref={columnRef}
            className={`rounded-3 kanbanCardContainer-${layout} ${
                isDraggedOver ? 'kanbanCardIsDraggedOver' : ''
            }`}
        >
            <h2 className="fs-5 text-center">{title}</h2>
            <div
                className={
                    'bg-white rounded-3 p-2 d-flex flex-column gap-2 shadow-lg kanbanPropCardsContainer'
                }
            >
                {items.map((item, index) =>
                    kanbanItemRenderer(item, index, onNotFeasible)
                )}
            </div>
        </div>
    );
};

export default KanbanCard;
